import { render, staticRenderFns } from "./RouteSegmentsConveyor.vue?vue&type=template&id=5804f87f&scoped=true"
import script from "./RouteSegmentsConveyor.vue?vue&type=script&lang=js"
export * from "./RouteSegmentsConveyor.vue?vue&type=script&lang=js"
import style0 from "./RouteSegmentsConveyor.vue?vue&type=style&index=0&id=5804f87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804f87f",
  null
  
)

export default component.exports